'use client'

import UIFlex, { UIFlexProps } from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'

interface SubSectionTitleProps extends Omit<UIFlexProps, 'ref'> {
	children: React.ReactNode
	rightSlot?: React.ReactNode
}
const SubSectionTitle = ({ children, rightSlot, ...props }: SubSectionTitleProps) => {
	return (
		<UIFlex
			pb={pxToRem(16)}
			flexDirection="row"
			alignItems="center"
			justifyContent="space-between"
			{...props}
		>
			<UIText
				fontSize={pxToRem(22)}
				lineHeight={pxToRem(32)}
				fontWeight={700}
				letterSpacing="-0.088px"
				flexGrow="1"
			>
				{children}
			</UIText>
			{rightSlot && (
				<Box flexShrink="0" minWidth="0">
					{rightSlot}
				</Box>
			)}
		</UIFlex>
	)
}

export default SubSectionTitle
